module.exports = __webpack_public_path__ + "static/media/icon-veloe-background.27f1a96c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon-veloe-background.svg
// module id = 137
// module chunks = 0